import { gql, useMutation } from '@apollo/client'
import { useNotification } from '@btime/react-messager'

import { documentsClient } from '../apollo/api'

const MUTATION = gql`
  mutation TransformDocument($id: Int!, $input: TransformInput!) {
    transformDocument(id: $id, input: $input) {
      id
      src
    }
  }
`

export const useTransformDocument = onChange => {
  const notify = useNotification()
  const [request, state] = useMutation(MUTATION, { client: documentsClient })

  const handleRequest = async (document, transform) => {
    return request({
      variables: { id: document.origin?.documentId || document.origin?.id, input: transform }
    }).then(resp => {
      if (!!resp.errors) {
        notify.error({ title: 'Erro ao fazer o upload do arquivo' })
        return
      }

      const transformedDocument = resp.data?.transformDocument

      const newDocument = { ...document, value: transformedDocument?.src, origin: transformedDocument }

      onChange && onChange(newDocument)

      return transformedDocument
    })
  }

  return [handleRequest, state]
}

export const useTransformDocumentOnList = (items, onChange) => {
  return useTransformDocument(newValue => {
    onChange(
      (items || []).map(item => {
        if ([item.documentId, item.id].includes(newValue.origin?.id)) {
          return { ...item, src: newValue.value }
        }
        return item
      }),
      newValue
    )
  })
}
